import React from "react";

import "./game.scss";
import { observer } from "mobx-react-lite";
import { CupCalendarGameType } from "../../../../schemas/cup_calendar";

function Game(props: { game: CupCalendarGameType }) {
	return (
		<div className="game">
			<div className="title">{props.game.name}</div>
			<div className="match_result">
				<div className="team">
					<div className="emblem">
						<img src={props.game.team_h.logo} alt="" />
					</div>
					<div className="team_name">{props.game.team_h.name}</div>
				</div>
				<div
					className="result"
					style={{
						fontSize: (!!props.game.score ? "40" : "24") + "px",
					}}
				>
					{props.game.score ??
						`${("00" + props.game.date?.day).slice(-2)}.${(
							"00" + props.game.date?.month
						).slice(-2)}\n${props.game.date?.time ?? ""}`}
				</div>
				<div className="team">
					<div className="emblem">
						<img src={props.game.team_g.logo} alt="" />
					</div>
					<div className="team_name">{props.game.team_g.name}</div>
				</div>
			</div>
			<div className="additional_text_wrapper">
				<span className="additional_text">
					{props.game.set}
					{props.game.set === "live" && (
						<div className="red_dot"></div>
					)}
				</span>
			</div>
			<div className="jump_button_wrapper">
				<div
					className="jump_button"
					onClick={() => (window.location.href = props.game.url)}
				>
					<span>Матч-Центр</span>
				</div>
			</div>
		</div>
	);
}

export default observer(Game);
